import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useSettings, useSeo } from "@/context/SettingsContext";
import { money } from "@/lib/api";
import { CardCancelledNotice } from "@/pages/CardPages";

export default function BookConfirmation() {
  const { ref } = useParams();
  const { settings } = useSettings();
  useSeo("Trial Request Received");
  return (
    <section className="bg-slate-50">
      <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6 sm:py-28">
        <div className="rounded-3xl border border-slate-200 bg-white p-8 text-center sm:p-14 animate-in fade-in zoom-in-95 duration-500" data-testid="booking-confirmation">
          <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-600" />
          <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-emerald-700">Request received</p>
          <p data-testid="booking-confirmation-message" className="mx-auto mt-4 max-w-xl font-display text-2xl font-bold leading-snug text-slate-900 sm:text-3xl">
            Thank you! Your {money(settings.trial_fee).replace(".00", "")} lawn mower trial request has been received. Our team will contact you to confirm eligibility, availability, and trial arrangements.
          </p>
          <div className="mx-auto mt-10 max-w-sm rounded-2xl border-2 border-dashed border-emerald-300 bg-emerald-50 p-6">
            <p className="text-sm text-emerald-800">Your booking reference</p>
            <p data-testid="booking-reference" className="mt-1 font-mono text-3xl font-bold tracking-wider text-slate-900">{ref}</p>
            <p className="mt-2 text-xs text-slate-500">Keep this for your records.</p>
          </div>
          <CardCancelledNotice />
          <div className="mx-auto mt-10 max-w-lg text-left text-sm leading-relaxed text-slate-600">
            <p className="font-semibold text-slate-900">What happens next</p>
            <ul className="mt-2 list-disc space-y-1.5 pl-5">
              <li>This is a request — your trial is not confirmed yet.</li>
              <li>You have not been charged. Any fee is disclosed and collected only after confirmation.</li>
              <li>{settings.phone ? `Questions? Call us on ${settings.phone}.` : "We'll be in touch shortly."}</li>
            </ul>
          </div>
          <Link to="/" data-testid="confirmation-home-link" className="mt-10 inline-flex h-12 items-center rounded-full bg-slate-900 px-7 font-semibold text-white hover:bg-slate-800">Back to home</Link>
        </div>
      </div>
    </section>
  );
}
